import { useEffect, useState } from 'react'

import { Elements } from '@stripe/react-stripe-js'
import CheckoutForm from './CheckoutForm'
import { loadStripe, Stripe } from '@stripe/stripe-js'
import './SavePaymentMethod.css'
import { STRIPE_PUBLISHABLE_KEY } from '../../config'

function SavePaymentMethod() {
  const [stripePromise, setStripePromise] =
    useState<Promise<Stripe | null> | null>(null)

  useEffect(() => {
    setStripePromise(loadStripe(STRIPE_PUBLISHABLE_KEY!))
  }, [])

  return (
    <>
      {stripePromise && (
        <Elements
          stripe={stripePromise}
          options={{
            mode: 'setup',
            currency: 'usd',
            payment_method_types: ['card'],
          }}
        >
          <CheckoutForm />
        </Elements>
      )}
    </>
  )
}

export default SavePaymentMethod
